import classnames from "classnames"
import React from "react"
import { ContainerQuery } from "react-container-query"

import Image from "@atoms/Image/Image"
import Shape from "@atoms/Shape/Shape"

import styles from "./ContactCard.module.scss"

const query = {
  "width-between-350-and-400": {
    minWidth: 350,
    maxWidth: 400,
  },
  "width-max-349": {
    maxWidth: 349,
  },
}

const ContactCard = ({
  children,
  image,
  type = "standard",
  placeholder = false,
}) => {
  const camelCase = require("camelcase")
  return (
    <ContainerQuery query={query}>
      {(params) => (
        <div className={classnames(params)}>
          <div className={`${styles.item} ${styles[camelCase("" + type)]}`}>
            {image && (
              <div className={styles.image}>
                <Image
                  image={image}
                  widths={[130, 260]}
                  fill={true}
                  ariaHidden={true}
                />
              </div>
            )}
            {!image && placeholder && (
              <div className={`${styles.image} ${styles.placeholder}`}></div>
            )}
            <div className={styles.text}>{children}</div>
            {type === "standard" && (
              <Shape
                type="triangle-bottom-left-large"
                context="sidebar"
                color="light-beige"
                x="1.2"
              />
            )}
          </div>
        </div>
      )}
    </ContainerQuery>
  )
}

export default ContactCard
